/** Resolved by the app's alert display. This is a message key, not display copy. */
export const DELETE_QUEUE_FAILED_MESSAGE_KEY = 'deleteQueueFailed';

/** Shown on a disabled delete control and when an action is refused because the tab is still loading. */
export const STILL_LOADING_MESSAGE = 'Still loading your data. Try again in a moment.';
